export default {
  'benchmark_less_selected_metrics': '请至少选中三个指标',
  'benchmark_add_games_to_compare': '选择竞品',
  'benchamrk_add': '添加',
  'benchamrk_add_search_any_game': '搜索',
  'benchmark_selected': '已选',
  'benchmark_clear_all': '清空',
  'benchmark_comparison': '对比',
  'benchmark_you_can_choose_up_to_9_games': '最多可选择{num}个游戏进行比较',
  'benchmark_compare_to_filter_name': '对比',
  'benchmark_compare_to_filter_genre_button': '品类',
  'benchmark_table_txchange_position': '交换位置',
  'benchmark_table_remove_this_game': '移除该游戏',
  'benchmark_table_add_sort_games': '添加游戏 & 排序',
  'benchmark_table_competitors': '竞品',
  'benchmark_table_high_risk': '高风险',
  'benchmark_table_medium_risk': '中风险',
  'benchmark_table_low_risk': '低风险',
  'benchmark_table_benchmark': '行业基准：',
};
